import * as React from "react"

import { cn } from "../../lib/utils.js"
import { NativePickerField } from "./native-picker-field.tsx"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // iOS refuses to shrink date and time inputs below their shadow DOM's intrinsic width, so
    // they overflow phones. NativePickerField draws the box and hides the real input on top of
    // it. Handled here so no call site has to know — see native-picker-field.tsx.
    if (type === "date" || type === "time") {
      return <NativePickerField type={type} className={className} inputRef={ref} {...props} />
    }

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-card px-3 py-2 text-base text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset disabled:pointer-events-none disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
